import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { AppComponent } from './app.component';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _authService: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        var parentRoute: string = state.url.split("/")[1];
        var childRoute: string = state.url.split("/")[2];
        var role: string = localStorage.getItem("userRole");
        var status: number = this._authService.getUserStatus();
        console.log(parentRoute);
        console.log(role);
        console.log(childRoute);
        console.log(status);
        if (parentRoute == "main") {
            if (role == "admin" || role == "superuser" || role == "user") {
                return true;
            } else {                
                this.router.navigate(['/main', 'dashboard']);
                return false;
            }
        } else if (parentRoute == "superuser") {
            if (role == "admin" || role == "superuser") {
                if(childRoute != "start" && childRoute != "transactionReturn") {
                    if(status == 1) {
                        return true;
                    } else {
                        this.router.navigate(['/superuser', 'start']);
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                this.router.navigate(['/main', 'dashboard']);
                return false;
            }
        } else {
            return false;
        }

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/auth-guard.service.ts
 **/